import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  GRAPH_PANEL_IMPORTS,
  GraphPanelComponent,
} from '../../../../panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-benchmarking-building-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class BenchmarkingBuildingGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.BenchmarkingBuildingGraph;
  public override unit = DisplayUnit.KwhSquareMeter;

  public override config: IGraphConfig = {
    sortOrder: [GraphType.EnvironmentElectricityBenchmarking, GraphType.EnvironmentGasBenchmarking],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  protected override graphInfo = {
    title: 'Benchmarking grafiek',
    description: `
      <p>Vergelijk het gebouw met vergelijkbare gebouwen op basis van de ingestelde gebruiksfunctie en het gebruikstype. Hierbij worden richtwaarden en referenties gebruikt die passen bij het type gebouw, zoals kantoor, hotel, winkel of zwembad. Hierdoor ontstaat een realistische vergelijking met gebouwen met een vergelijkbaar gebruiksprofiel.</p>
      <p>Het energieverbruik wordt weergegeven in kWh/m², zodat gebouwen onafhankelijk van grootte eerlijk met elkaar vergeleken kunnen worden.</p>
      <p>Benchmarking ten opzichte van de referentiegroep is alleen beschikbaar wanneer benchmarking-data anoniem gedeeld mag worden. Dit kan worden beheerd via de instelling <strong>‘Benchmarking opt-in’</strong> op de organisatiepagina.</p>
      `,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.EnvironmentElectricityBenchmarking:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Electriciteit',
          Color.Purple,
          DisplayUnit.KwhSquareMeter,
        );
      case GraphType.EnvironmentGasBenchmarking:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Gas', Color.Gray, DisplayUnit.KwhSquareMeter);
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
